"use client";

import { c as _c } from "react/compiler-runtime";
import { UtilityBar } from "./utility-bar.component";
import { PrimaryNavbar } from "./primary-navbar.component";
import { useNavigationState } from "@/components/navigation/navigation-provider";
import type { NavigationData } from "@/components/navigation/navigation.types";
interface DesktopNavbarProps {
  navigationData: NavigationData;
}
export function DesktopNavbar(t0) {
  const $ = _c(10);
  const {
    navigationData
  } = t0;
  const {
    logo,
    utilityMenu,
    primaryMenuItems,
    businessPrimaryMenuItems
  } = navigationData;
  const {
    isSearchOpen
  } = useNavigationState();
  const t1 = utilityMenu?.items ?? null;
  let t2;
  if ($[0] !== t1) {
    t2 = <UtilityBar items={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== businessPrimaryMenuItems || $[3] !== isSearchOpen || $[4] !== logo || $[5] !== primaryMenuItems) {
    t3 = !isSearchOpen && <PrimaryNavbar logo={logo} menuItems={primaryMenuItems} businessMenuItems={businessPrimaryMenuItems} />;
    $[2] = businessPrimaryMenuItems;
    $[3] = isSearchOpen;
    $[4] = logo;
    $[5] = primaryMenuItems;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="hidden desktop-lg:flex desktop-lg:flex-col">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}